import React from 'react';
import Button from 'v3/components/Button';

/** Mensagens extras (children) ficam dentro do quadro, que tem fundo claro sobre a faixa do cabeçalho. */
export default function AttendanceNotice({ attendance, busy = false, children }) {
  const { record, error, back, accessPending } = attendance;
  if (!record && !error && !accessPending) return null;
  return (
    <div
      className="tc-attendance-notice"
      role={error ? 'alert' : 'status'}
      style={{
        padding: 16,
        marginBottom: 16,
        background: '#edf6f5',
        border: '1px solid #badbd6',
        borderRadius: 6,
      }}
    >
      <p style={{ marginBottom: 8 }}>
        {error ||
          (accessPending
            ? 'Confirmando acesso ao atendimento…'
            : `${record.mode === 'OTHER' ? 'Atendimento com outro veículo' : 'Atendimento pelo Kanban'}: ${[record.selection.vehicle, ...record.selection.wagons].map((a) => a.plate).join(' / ')} · ${record.selection.driver ? record.selection.driver.name || 'Motorista selecionado' : 'sem motorista: informe o motorista no cadastro'}. O aceite será registrado ao salvar com sucesso.`)}
      </p>
      {children}
      <Button variant="secondary" size="sm" disabled={busy} onClick={back}>
        Cancelar e voltar ao Kanban
      </Button>
    </div>
  );
}
